import { render } from "./CrearTicketAnidadoComponent.vue?vue&type=template&id=0fa42a52"
import script from "./CrearTicketAnidadoComponent.vue?vue&type=script&lang=js"
export * from "./CrearTicketAnidadoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__